<script>
import TableRowActions from "@/shared/ui/custom/components/TableRowActions.vue";
import {
  Table,
  TableBody,
  TableCell,
  TableEmpty,
  TableHead,
  TableHeader,
  TableRow,
} from "@/shared/ui/table";
import Button from "@/shared/ui/button/Button.vue";

export default {
  name: "LoggingSessions",
  components: {
    Button,
    TableRowActions,
    Table,
    TableBody,
    TableCell,
    TableEmpty,
    TableHead,
    TableHeader,
    TableRow,
  },
  props: {
    logItem: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
    list() {
      return this.logItem ? [this.logItem] : [];
    },
    actions() {
      return [
        {
          label: "Завершить сессию",
          type: "danger",
          action: "block",
          icon: "huge-close",
        },
      ];
    },
  },
  methods: {
    handleActions() {},
  },
};
</script>

<template>
  <div class="block">
    <div class="h-full overflow-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead class="w-[68px]"></TableHead>
            <TableHead class="min-w-[319px]">SessionID</TableHead>
            <TableHead class="min-w-[319px]">{{
              $t("Сессия начата")
            }}</TableHead>
            <TableHead class="min-w-[319px]">{{
              $t("Сессия завершена")
            }}</TableHead>
            <TableHead class="min-w-[319px]">{{
              $t("Рабочая станция")
            }}</TableHead>
            <TableHead class="min-w-[319px]">{{
              $t("Статус сессии")
            }}</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          <TableEmpty v-if="!list.length" :colspan="6"> Нет данных </TableEmpty>
          <TableRow
            v-for="row in list"
            :key="row.user?.session_id || row.timestamp"
          >
            <TableCell class="text-center">
              <!-- TODO: временно скрыто — нет реализации на бэкенде -->
              <!-- <TableRowActions
                :actions="actions"
                align="end"
                @action="handleActions({ action: $event.action, rowData: row })"
              /> -->
            </TableCell>

            <TableCell>
              <div
                v-if="row.user?.session_id?.length"
                class="text-sm font-semibold text-foreground"
              >
                {{ row.user.session_id }}
              </div>
              <div v-else>{{ $t("Не указано") }}</div>
            </TableCell>

            <TableCell>
              <div
                v-if="row.timestamp?.length"
                class="text-sm font-medium text-foreground"
              >
                {{ row.timestamp }}
              </div>
              <div v-else>{{ $t("Не указано") }}</div>
            </TableCell>

            <TableCell>
              <div
                v-if="row.timestamp_end?.length"
                class="text-sm font-medium text-foreground"
              >
                {{ row.timestamp_end }}
              </div>
              <div v-else>{{ $t("Не указано") }}</div>
            </TableCell>

            <TableCell>
              <div
                v-if="row.ip?.length"
                class="text-sm font-bold text-foreground"
              >
                {{ row.ip }}
              </div>
              <div v-else>{{ $t("Не указано") }}</div>
            </TableCell>

            <TableCell>
              <div
                v-if="row.status?.length"
                class="text-sm font-medium text-foreground"
              >
                {{ row.status }}
              </div>
              <div v-else>{{ $t("Не указано") }}</div>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
  </div>
</template>

<style scoped lang="scss">
.block {
  @apply h-full w-full overflow-auto bg-card rounded-2xl;
}
</style>
